module.exports = __webpack_public_path__ + "img/activityAdd.e0e13332.svg";